import { Box, BoxProps } from "@chakra-ui/react";

export function OrgIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.166 23.8327V8.66602C15.166 5.60189 15.166 4.06982 14.2141 3.11792C13.2622 2.16602 11.7301 2.16602 8.66602 2.16602C5.60189 2.16602 4.06982 2.16602 3.11792 3.11792C2.16602 4.06982 2.16602 5.60189 2.16602 8.66602V17.3327C2.16602 20.3968 2.16602 21.9289 3.11792 22.8808C4.06982 23.8327 5.60189 23.8327 8.66602 23.8327H15.166Z"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
        <path
          d="M7.04232 11.9173H5.95898M11.3757 11.9173H10.2923M7.04232 7.58398H5.95898M7.04232 16.2507H5.95898M11.3757 7.58398H10.2923M11.3757 16.2507H10.2923"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
        <path
          d="M20.0423 16.2493H18.959M20.0423 11.916H18.959"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
        <path
          d="M19.4993 8.66602H15.166V23.8327H19.4993C21.5421 23.8327 22.5635 23.8327 23.1981 23.1981C23.8327 22.5635 23.8327 21.5421 23.8327 19.4993V12.9993C23.8327 10.9566 23.8327 9.93522 23.1981 9.30062C22.5635 8.66602 21.5421 8.66602 19.4993 8.66602Z"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
        />
      </svg>
    </Box>
  );
}
